import FilterGallaryTwo from "../components/common/filter-gallary/filter-gallary-two";
import BreadcrumbOne from "./../components/common/breadcrumb/breadcrumb-one";

export default function PortfolioOne() {
	return (
		<>
			<BreadcrumbOne title="Portfolio o1" />
			<FilterGallaryTwo />
		</>
	);
}
